/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "./router";
import LRS from "./services/lrsService";
import userService from "./services/userService";
import translationService from "./services/translationService";
import i18n from "./i18n";
import localUsers from "./users/user.json";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: localStorage.getItem("user") || "",
        translation: localStorage.getItem("translation") || "",
        lang: localStorage.getItem("lang") || "",
        country: localStorage.getItem("country") || "",
        moduleStatus: [],
        modulePercent: 0,
        modulename: localStorage.getItem("modulename") || "",
        chapters: 0,
        attemptNumber: 1,
        quizSuccessful: false
    },
    mutations: {
        init(state, {user, translation, lang, country, chapters, moduleStatus, modulePercent, module}) {
            state.user = user;
            state.translation = translation;
            state.lang = lang;
            state.country = country;
            state.chapters = chapters;
            state.moduleStatus = moduleStatus;
            state.modulePercent = modulePercent;
            state.modulename = module;

        },
        setLanguage(state, {translations, lang}){
            state.translation = translations;
            state.lang = lang;
        },
        updateModuleStatus(state, chapter) {

            let array = [chapter];
            let shouldBeAdded = true;

            for (let i = 0; i < state.moduleStatus.length; i++) {
                if(state.moduleStatus[i][0] == chapter){
                    shouldBeAdded = false;
                }
            }

            if (shouldBeAdded) {
                state.moduleStatus.push(array);
            }
        },
        updateModulePercent(state, progress) {

            state.modulePercent = progress;
        },
        updateUserQuizAttempts(state){
            state.user.quiz_attempts++;
        },
        updateQuizSuccessful(state){
            state.quizSuccessful = true;
        },
    },

    actions: {

        enterModuleLocal({commit}, {module, lang, chapters}) {
            let user;

            userService.getUserLocal(module).then(function (response) {
                user = response.data;
                let lang = user.user.language.toLowerCase();
                let country = user.user.country.toLowerCase();
                let moduleStatus = [];
                let progress = user.experienced;

                progress.forEach(function (el) {
                    moduleStatus.push([el.id]);
                });

                // let modulePercent = (progress.length / chapters) * 100;
                let modulePercent = 100;

                translationService.getLanguageLocal().then(function (res) {
                    let translationToInterpolate = res.data[0];

                    let interpolation = {
                        '{red}': '<span class="font-color-red">',
                        '{/red}': '</span>',
                        '{quote}': '"',
                        '{br}': '<br>',
                        '{bold}': '<strong>',
                        '{/bold}': '</strong>',
                        '{italic}': '<em>',
                        '{/italic}': '</em>',
                        '{uppercase}': '<span class="text-uppercase">',
                        '{/uppercase}': '</span>',
                        '{small}': '<small>',
                        '{/small}': '</small>',
                        '{sup}': '<sup>',
                        '{/sup}': '</sup>',
                        '{nobreak}': '<span class="nobr">',
                        '{/nobreak}': '</span>',
                        '{span}': '<span>',
                        '{/span}': '</span>',
                    }

                    Object.keys(translationToInterpolate).forEach(key => {
                        let value = translationToInterpolate[key];
                        //Für jeden Sprachschlüssel alle interpolations druch gehen
                        Object.entries(interpolation).forEach(entry => {
                            let interpolationKey = entry[0];
                            let interpolationValue = entry[1];
                            // hat Sprachschlüssel einen interpolation Tags?
                            if (value.indexOf(interpolationKey) !== -1) {
                                // Replace
                                value = value.replace(new RegExp(interpolationKey, 'g'), interpolationValue);
                                translationToInterpolate[key] = value;
                            }
                        });
                    });

                    translationToInterpolate = JSON.stringify(translationToInterpolate)
                    i18n.setLocaleMessage("en", JSON.parse(translationToInterpolate))



                    commit("init", {
                        user,
                        translationToInterpolate,
                        lang,
                        country,
                        chapters,
                        moduleStatus,
                        modulePercent,
                        module
                    });

                    document.querySelector('.preloader').classList.add("hide");
                })
            })

        },

        enterModule({ commit }, {module, lang, chapters}) {
            return new Promise((resolve, reject) => {
                let user;
                userService.getUser(module).then(function (response) {
                    let data = response.data;
                    user = data;
                    let lang = user.user.language.toLowerCase();
                    let country = user.user.country.toLowerCase();

                    let moduleStatus = [];
                    let progress = user.experienced;

                    progress.forEach(function (el) {
                        moduleStatus.push([el.id]);
                    });

                    let modulePercent = (progress.length / chapters) * 100;

                    if (user.user.is_member === 0) {
                        window.location.replace("https://www.discover-shiseido.com/uk_en/membersonly/");
                    }

                    translationService.getLanguage(module, country, lang).then(function (res) {
                        let translation = JSON.stringify(res.data);
                        let translationToInterpolate = res.data;

                        let interpolation = {
                            '{red}': '<span class="font-color-red">',
                            '{/red}': '</span>',
                            '{highlight}': '<span class="color-highlight">',
                            '{/highlight}': '</span>',
                            '{quote}': '"',
                            '{br}': '<br>',
                            '{bold}': '<strong>',
                            '{/bold}': '</strong>',
                            '{italic}': '<em>',
                            '{/italic}': '</em>',
                            '{uppercase}': '<span class="uppercase">',
                            '{/uppercase}': '</span>',
                            '{small}': '<small>',
                            '{/small}': '</small>',
                            '{sup}': '<sup>',
                            '{/sup}': '</sup>',
                            '{nobreak}': '<span class="nobr">',
                            '{/nobreak}': '</span>',
                            '{span}': '<span>',
                            '{/span}': '</span>',
                        }

                        Object.keys(translationToInterpolate).forEach(key => {
                            let value = translationToInterpolate[key];

                            //Für jeden Sprachschlüssel alle interpolations druch gehen
                            Object.entries(interpolation).forEach(entry => {
                                let interpolationKey = entry[0];
                                let interpolationValue = entry[1];
                                // hat Sprachschlüssel einen interpolation Tags?
                                if(value.indexOf(interpolationKey) !== -1){
                                    // Replace
                                    value = value.replace(new RegExp(interpolationKey, 'g'), interpolationValue);
                                    translationToInterpolate[key] = value;
                                }
                            });
                        });

                        translationToInterpolate = JSON.stringify(translationToInterpolate)
                        i18n.setLocaleMessage("en", JSON.parse(translationToInterpolate))

                        commit("init", {user, translationToInterpolate, lang, country, chapters, moduleStatus, modulePercent, module});
                        localStorage.setItem("user", JSON.stringify(user));
                        localStorage.setItem("translation", translationToInterpolate);
                        localStorage.setItem("lang", lang);
                        localStorage.setItem("country", country);
                        localStorage.setItem("chapters", chapters);
                        localStorage.setItem("moduleStatus", moduleStatus);
                        localStorage.setItem("modulePercent", modulePercent);
                        localStorage.setItem("modulename", module);

                        document.querySelector('.preloader').classList.add("hide");
                        resolve();
                        LRS.sendLRS("launched");
                    })
                })
            })

        },
        updateModuleStatus({commit}, chapter) {
            commit("updateModuleStatus", chapter);
        },
        updateModulePercent({commit}, progress) {
            commit("updateModulePercent", progress);
        },
        sendQuizAttempt({commit}){
            commit("updateUserQuizAttempts");
        },
        updateAttemptNumber({commit}){
            commit("updateAttemptNumber");
        },
        setAttemptNumber({commit}, number){
            commit("setAttemptNumber");
        },
        updateQuizSuccessful({commit}){
            commit("updateQuizSuccessful");
        }

    },
    getters: {
        user(state){
            return state.user;
        },
        moduleStatus(state) {
            return state.moduleStatus;
        },
        modulePercent(state) {
            return state.modulePercent;
        },
        translation(state){
            return state.translation;
        },
        lang(state) {
            return state.lang;
        },
        country(state) {
            return state.country;
        },
        maxChapters(state) {
            return state.chapters;
        },
        modulename(state){
            return state.modulename;
        },
        attemptNumbers(state){
            return state.attemptNumber;
        },
        quizSuccessful(state){
            return state.quizSuccessful;
        }
    }
});